<template>
<div class='vx-col w-full mt-4'>
    <!--preguntas columnas-->
    <div v-if="tipo == 5">
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" :placeholder="datos.columna1" :label="datos.columna1" v-model="opciones.resp" />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" :placeholder="datos.columna2" :label="datos.columna2" v-model="opciones.caracteristica" />
            </div>
        </div>
    </div>
    <div class="vx-row" v-else>
        <div class="vx-col w-full">
            <b class="m-3">Opción:</b>
            <vs-switch color="success" v-model="opciones.opcion" style="height: 30px;">
                <span slot="on">Correcta</span>
                <span slot="off">Incorrecta</span>
            </vs-switch>
            <br>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-4">
            <small class="mt-5">Respuesta:</small>
            <vs-textarea theme="snow" rows="6" v-model="opciones.resp" placeholder="ingrese la respuesta" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-4">
            <b class="m-3">Agregar imagen:</b>
            <FileUploadVue class="mt-1" v-model="archivoOpcion" modelName="archivoOpcion" :ObjectSelected="Object(ObjectSelectedOpcion)" :id="opciones.id" :carpeta="carpeta" />
        </div>        
    </div>
    <div class="flex justify-center mt-5" style="margin-top: -15px;">
        <vs-button icon-pack="feather" icon="icon-plus" class="mr-2" :color="propiedades.color_boton_opcion" @click="f_agregar_editar_opciones()">{{propiedades.txt_opciones}}</vs-button>
    </div>
</div>
</template>

<script>
const FileUploadVue = () => import('../../../admin/reutilizable/Files/FileUpload.vue');
import GeneralMixin from '../../../../mixins/GeneralMixin';
export default {
    components: {
        FileUploadVue,
    },
    mixins: [GeneralMixin],
    data() {
        return {
            opciones: {
                id: 0,
                opcion: false,
                resp: '',
                caracteristica: '',
                imagen: '',
            },
            propiedades: {
                color_boton_opcion: 'success',
                txt_opciones: 'Agregar',
            },
            archivoOpcion: null,
            carpeta: 'opcion_preguntas',
            imgOld: '',
            //variables opcion
        }
    },
    props: {
        datos: {
            type: Object,
            default: function () {
                return {}
            }
        },
        idOpcion: {
            type: Number,
            default: 0
        },
        ObjectSelectedOpcion: {
            type: Object,
            default: function () {
                return {}
            }
        },
        tipo:{
            type:Number,
            required:true,
            default:0
        },
        tipoSelect:{
            type:Number,
            default:0
        },
    },
    mounted() {
        let me = this;
        me.iniciar();
    },
    methods: {
        iniciar() {
            let me = this;
            if (me.idOpcion > 0) {
                me.opciones = {
                        id: me.ObjectSelectedOpcion.id,
                        opcion: me.ObjectSelectedOpcion.opcion == 'true' ? true : false,
                        resp: me.ObjectSelectedOpcion.respuesta,
                        caracteristica: me.ObjectSelectedOpcion.caracteristica,
                    },
                    me.imgOld = me.ObjectSelectedOpcion.url;
                me.propiedades.txt_opciones = 'Editar opción';
                me.propiedades.color_boton = 'warning';
            } else {
                me.opciones = {
                    id: 0,
                    opcion: false,
                    resp: '',
                    caracteristica: '',
                    imagen: '',
                }
            }
        },
        f_agregar_editar_opciones() {
            let me = this;
            if (me.opciones.resp == '') {
                me.propiedades.mensaje = "Ingrese una respuesta";
                me.f_notificaciones(me.propiedades.mensaje, "warning");
                return;
            }
            me.$vs.loading();
            let formdatas = new FormData();
            formdatas.append('id', me.opciones.id);
            formdatas.append('id_pregunta', me.datos.id);
            formdatas.append('opcion', me.opciones.opcion);
            formdatas.append('resp', me.opciones.resp);
            formdatas.append('caracteristica', me.opciones.caracteristica == null ? '' : me.opciones.caracteristica);
            formdatas.append('img_opcion', 'imagen ruta');
            me.$http.post(this.$server_url + 'guardar_opcion', formdatas)
                .then((res) => {
                    if(res.data.status == 0){
                        me.$vs.loading.close();
                        me.f_notificaciones(res.data.message, "danger");
                        return;
                    }
                    if (me.opciones.id > 0) {
                        me.propiedades.mensaje = "Opcion editada correctamente";
                        me.propiedades.color_notify = 'warning'
                    } else {
                        me.opciones = res.data;
                        // me.datos.id = res.data.id;
                        me.propiedades.mensaje = "Opcion registrada correctamente";
                        me.propiedades.color_notify = 'success'
                        me.propiedades.txt_opciones = 'Editar opción';
                        me.propiedades.color_boton = 'warning';
                    }
                    me.guardarFiles(res.data.id, me.archivoOpcion);
                    me.f_notificaciones(me.propiedades.mensaje, me.propiedades.color_notify);
                    me.$vs.loading.close();
                })
                .catch(err => {
                    console.log(err)
                    me.$vs.loading.close();
                    me.$vs.notify({
                        title: 'Error',
                        text: 'Error al guardar la opción',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                })
        },
        guardarFiles(getId, file) {
            let me = this;
            let formData = new FormData();
            formData.append('id', getId)
            formData.append('archivo1', file)
            formData.append('imgOld', me.imgOld)
            formData.append('ruta', me.carpeta)
            //save en tabla
            //nombre modelo
            formData.append('nombreM', "PreguntaOpcion")
            formData.append('guardarTabla', "1")
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            this.$http.post(this.$data_url + 'api/guardarDocumentos', formData, config)
                .then((result) => {
                    me.$emit('changeHandle', true);
                    me.$emit('change_pregunta_editada', true);
                }).catch((err) => {});
        },
    }
}
</script>
